<template>
  <div id="dialog-spin">
    <div class="spinner">
      <div class="spinner-circle">
        <div class="spinner-circle__fill"></div>
      </div>
    </div>
    <p>POČAKAJTE...</p>
  </div>
</template>

<script>
export default {
  created() {
    document.querySelector("body").style.overflow = "hidden";
  },
  destroyed() {
    document.querySelector("body").style.overflow = "auto";
  },
};
</script>

<style scoped>
#dialog-spin {
  border-radius: 20px;
  background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%) !important;
  width: 280px;
  height: 280px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#dialog-spin .spinner {
  width: 75px;
  height: 75px;
  margin-bottom: 30px;
}

#dialog-spin .spinner .spinner-circle {
  width: 75px;
  height: 75px;
  margin-bottom: 30px;

  border-radius: 100%;
  background-color: white;

  display: flex;
  justify-content: center;
  align-items: center;
}

#dialog-spin .spinner .spinner-circle .spinner-circle__fill {
  width: 55px;
  height: 55px;
  background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%) !important;

  border-radius: 100%;

  animation: scale 5s infinite ease-out;
}

#dialog-spin p {
  color: #1ea89c;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 22px;
  border-radius: 20px;
  transform-origin: center center;

  margin: 0;

  color: white;

  animation: fade 5s infinite linear;
}

@keyframes rotate {
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
}

@keyframes scale {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.5);
  }
}

@keyframes fade {
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
</style>
